module.exports = "/static-assets/_next/static/images/img-9fbdeb8975-fb2d11a8bd8288e574f8001c907ac574.webp";